import { relatorios } from '../utils/constants'

export default [
  {
    icon: 'mdi-monitor-dashboard',
    title: 'Início',
    to: '/tecnico/dashboard',
  },
  {
      icon: 'mdi-note-text',
      title: 'Relatórios',
      group: '/tecnico/relatorio',
      children: [
        {
          icon: 'mdi-circle-medium',
          title: 'Serviços efetuados por produtor',
          subtitle: 'Produtor',
          to: relatorios.servicosProdutor,
        },
        {
          icon: 'mdi-circle-medium',
          title: 'Serviços por Técnico',
          subtitle: 'Resumo',
          to: relatorios.servicoTecnicos,
        },
        {
          icon: 'mdi-circle-medium',
          title: 'Atendimentos por Empresa',
          subtitle: 'Empresa',
          to: relatorios.atendimentoEmpresa,
        },
        {
          icon: 'mdi-circle-medium',
          title: 'Resumo dos Serviços',
          subtitle: 'Resumo',
          to: relatorios.resumoServicos,
        },
      ],
    },
]
